import { render, staticRenderFns } from "./PersonalizationCard.vue?vue&type=template&id=0612705b&scoped=true"
import script from "./PersonalizationCard.vue?vue&type=script&lang=js"
export * from "./PersonalizationCard.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationCard.vue?vue&type=style&index=0&id=0612705b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0612705b",
  null
  
)

export default component.exports